import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Modal, Table } from "react-bootstrap";
import * as moment from "moment";
//Redux
import { connect } from "react-redux";
import "./TablaCalificaciones.scss";
import { useParams } from "react-router-dom";
import DetallePuntosModal from "./DetallePuntosModal";

const TablaCalificaciones = (props) => {
	const { calificaciones } = props;
	const { idCapacitacion } = useParams();
	const { usuario, detalleNivel } = useSelector(state => state.usuario);
	const idEstudiante = detalleNivel?.[0]?.id_estudiante;
	const [showModal, setShowModal] = useState(false);

	const totalPuntos = calificaciones?.detalles
		? calificaciones.detalles.reduce((accFila, fila) => {
			return (
				accFila +
				fila.children.reduce((accChild, child) => {
					return accChild + (child.puntos ? parseInt(child.puntos, 10) : 0);
				}, 0)
			);
		}, 0)
		: 0;

	const puntosAdicionales = calificaciones?.puntos_adicionales
		? parseInt(calificaciones.puntos_adicionales, 10)
		: 0;

	const puntosAcumulados = totalPuntos + puntosAdicionales;
	const notaActual = Math.min(20, Math.floor(puntosAcumulados / 50));

	const faltanPara14 = Math.max(700 - puntosAcumulados, 0);
	const faltanPara20 = Math.max(1000 - puntosAcumulados, 0);

	const fillWidth = Math.min(100, Math.round((puntosAcumulados / 1000) * 100));
	const mostrarDetallePuntos =
		(parseInt(idCapacitacion) >= 45 && parseInt(idCapacitacion) !== 100) ||
		parseInt(idCapacitacion) === 31 ||
		parseInt(idCapacitacion) === 32 ||
		parseInt(idCapacitacion) === 35;

	const handleDetallePuntosAdicionales = () => {
		setShowModal(true);
	};

	const handleCloseModal = () => {
		setShowModal(false);
	};

	return (
		<div className="tabla-calificaciones table-responsive">
			<Table className="tabla">
				<thead>
					<tr>
						<th>M&oacute;dulo</th>
						<th>Sesi&oacute;n</th>
						<th>Fecha</th>
						<th>Nota</th>
						<th>Puntos</th>
						<th>Asistencia</th>
					</tr>
				</thead>
				<FilasTabla calificaciones={calificaciones} />
			</Table>

			<div className="resumen-calificaciones-card">
				<h2 className="sr-only">Calificaci&oacute;n INEDIRank: nota {notaActual}, {puntosAcumulados} puntos acumulados</h2>
				<div className="top">
					<div>
						<div className="detalle-label">Nota actual</div>
						<div className="grade">
							<span className="grade-num">{notaActual}</span>
							<span className="grade-denom">/ 20</span>
						</div>
					</div>
					<div className="pts-col">
						<div className="pts-main">{puntosAcumulados} Puntos </div>
						<div className="pts-label">Total acumulado</div>
					</div>
				</div>

				<div className="track">
					<div className="fill" style={{ width: `${fillWidth}%` }}></div>
					<div className="track-marker"></div>
				</div>

				<div className="track-labels">
					<span className="label-start">0</span>
					<span className="label-mid">700</span>
					<span className="label-end">1000</span>
				</div>

				<div className="metrics">
					<div className="met">
						<div className="met-val">{totalPuntos}</div>
						<div className="met-lbl">Puntos por Evaluaciones</div>
					</div>

					<div className="met">
						<div className="met-content">
							<div className="met-val">{puntosAdicionales}</div>
							<div className="met-lbl">Puntos Adicionales</div>
						</div>
					</div>

					<div className="met met--flex">
						{puntosAcumulados < 700 ? (
							<>
								<div className="met-val danger">{faltanPara14}</div>
								<div className="met-lbl">Puntos Pendientes para 14</div>
							</>
						) : notaActual >= 20 ? (
							<>
								<div style={{ display: 'flex', alignItems: 'center', gap: '6px', justifyContent: 'center' }}>
									<div className="met-val">20</div>
									<span style={{ fontSize: '16px' }}>🏆</span>
								</div>
								<div className="met-lbl">¡Nota máxima!</div>
							</>
						) : (
							<>
								<div className="met-val">{faltanPara20}</div>
								<div className="met-lbl">Puntos pendientes para 20</div>
							</>
						)}
					</div>

				</div>

				{mostrarDetallePuntos ? (
					<div className="detalle-puntos-action">
						<button
							className="btn button-detalle"
							onClick={handleDetallePuntosAdicionales}
						>
							Ver detalle
						</button>
					</div>
				) : null}

				<div className="hint">
					{notaActual >= 20
						? "¡Felicitaciones! Lograste la nota máxima."
						: puntosAcumulados < 700
							? "Necesitas 700 puntos para aprobar"
							: "Cada 50 puntos sube 1 punto en tu nota final"}
				</div>
			</div>

			<Modal
				show={showModal}
				onHide={handleCloseModal}
				className="puntos-adicionales-modal"
				centered
			>
				<Modal.Header closeButton>
					<Modal.Title>Puntos adicionales</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<DetallePuntosModal
  id_estudiante={idEstudiante}
  id_proyecto={idCapacitacion}
  puntosAsistencia={calificaciones?.puntos_asistencia || 0}
  onClose={handleCloseModal}
/>


				</Modal.Body>
			</Modal>
		</div>
	);
};

const mapStateToProps = (state) => ({
	calificaciones: state.cursos.calificaciones,
});
export default connect(mapStateToProps, {})(TablaCalificaciones);

const FilasTabla = (props) => {
	const { calificaciones } = props;

	return (
		<>
			<tbody>
				{calificaciones.detalles &&
					calificaciones.detalles.map((fila, index) => (
						<React.Fragment key={index}>
							{fila.children.map((sesion, index) => (
								<React.Fragment key={index}>
									{index < 1 ? (
										<tr key={fila.id}
											className={
												sesion.promediable === "1" || sesion.id_tipo_sesion == 2
													? "font-weight-bold"
													: ""
											}>
											<td
												rowSpan={fila.children.length}
												title={fila.nombre}
												className="td-modulo position-relative"
											>
												<div className="content-nombre-modulo w-100 h-100 position-absolute d-flex align-items-center font-weight-bold">
													<p>
														{fila.nombre.length > 50
															? `${fila.nombre.substr(
																0,
																50
															)}...`
															: fila.nombre}
													</p>
												</div>
											</td>
											<td
												className="td-nombre-sesion"
												title={sesion.nombre}
											>
												{sesion.nombre}
											</td>
											<td>
												{moment(sesion.fecha).format(
													"DD/MM/YYYY"
												)}
											</td>
											<td className="text-center">
												{parseInt(sesion.nota)}
											</td>
											<td className="text-center">
												{parseInt(sesion.puntos)}

											</td>
											<td>{sesion.asistencia}</td>
										</tr>
									) : (
										<tr key={fila.id}
											className={
												sesion.promediable === "1" || sesion.id_tipo_sesion == 2
													? "font-weight-bold"
													: ""
											}>
											<td title={sesion.nombre} >
												{sesion.nombre}
											</td>
											<td>
												{moment(sesion.fecha).format(
													"DD/MM/YYYY"
												)}
											</td>
											<td className="text-center">
												{parseInt(sesion.nota)}
											</td>
											<td className="text-center">
												{parseInt(sesion.puntos)}
											</td>
											<td>{sesion.asistencia}</td>
										</tr>
									)}
								</React.Fragment>
							))}
						</React.Fragment>

					))}
			</tbody>
		</>
	);
};
